// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type AddUserToCertificationMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  userId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type AddUserToCertificationMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { certification?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CertificationModelAsAdmin' }
      & Pick<PrivateSchemaTypes.CertificationModelAsAdmin, 'id'>
      & { addUser?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CertificationModelAsAdmin' }
        & Pick<PrivateSchemaTypes.CertificationModelAsAdmin, 'id'>
        & { users: Array<(
          { __typename?: 'UserModelPublicBase' }
          & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'image_url' | 'userIdentity' | 'profile_img_url'>
        )> }
      )> }
    )> }
  )> }
);

export type RemoveUserFromCertificationMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  userId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type RemoveUserFromCertificationMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { certification?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CertificationModelAsAdmin' }
      & Pick<PrivateSchemaTypes.CertificationModelAsAdmin, 'id'>
      & { removeUser?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CertificationModelAsAdmin' }
        & Pick<PrivateSchemaTypes.CertificationModelAsAdmin, 'id'>
        & { users: Array<(
          { __typename?: 'UserModelPublicBase' }
          & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'image_url' | 'userIdentity' | 'profile_img_url'>
        )> }
      )> }
    )> }
  )> }
);

export type ShareCertificationWithUsersMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  userIds: Array<PrivateSchemaTypes.Scalars['PositiveInt']> | PrivateSchemaTypes.Scalars['PositiveInt'];
  targetDate?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['DateTime']>;
  message?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['String']>;
  sendEmail: PrivateSchemaTypes.Scalars['Boolean'];
  resetEnrolments: PrivateSchemaTypes.Scalars['Boolean'];
  emailIdentityId?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['PositiveInt']>;
}>;


export type ShareCertificationWithUsersMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { certification?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CertificationModelAsAdmin' }
      & Pick<PrivateSchemaTypes.CertificationModelAsAdmin, 'id' | 'shareWithUsers'>
    )> }
  )> }
);

export type ShareCertificationWithGroupsMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  groupIds: Array<PrivateSchemaTypes.Scalars['PositiveInt']> | PrivateSchemaTypes.Scalars['PositiveInt'];
  targetDate?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['DateTime']>;
  message?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['String']>;
  sendEmail: PrivateSchemaTypes.Scalars['Boolean'];
  resetEnrolments: PrivateSchemaTypes.Scalars['Boolean'];
  emailIdentityId?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['PositiveInt']>;
}>;


export type ShareCertificationWithGroupsMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { certification?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CertificationModelAsAdmin' }
      & Pick<PrivateSchemaTypes.CertificationModelAsAdmin, 'id' | 'shareWithGroups'>
    )> }
  )> }
);

export type AccessCertificationUsersQueryVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  limit: PrivateSchemaTypes.Scalars['NonNegativeInt'];
  offset: PrivateSchemaTypes.Scalars['NonNegativeInt'];
  order?: PrivateSchemaTypes.Maybe<Array<PrivateSchemaTypes.OrderDescriptor> | PrivateSchemaTypes.OrderDescriptor>;
  filters?: PrivateSchemaTypes.Maybe<Array<PrivateSchemaTypes.UserModelPublicBaseFilterInput> | PrivateSchemaTypes.UserModelPublicBaseFilterInput>;
}>;


export type AccessCertificationUsersQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { certification?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CertificationModelAsAdmin' }
      & Pick<PrivateSchemaTypes.CertificationModelAsAdmin, 'id' | 'usersCount'>
      & { users: Array<(
        { __typename?: 'UserModelPublicBase' }
        & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name' | 'image_url' | 'email'>
      )> }
    )> }
  )> }
);

export type CertificationIsSharingCompletedQueryVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type CertificationIsSharingCompletedQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { certification?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CertificationModelAsAdmin' }
      & Pick<PrivateSchemaTypes.CertificationModelAsAdmin, 'id' | 'isSharingCompleted'>
    )> }
  )> }
);


export const AddUserToCertificationDocument = gql`
    mutation addUserToCertification($id: PositiveInt!, $userId: PositiveInt!) {
  admin {
    certification(id: $id) {
      id
      addUser(userId: $userId) {
        id
        users {
          id
          image_url
          userIdentity
          profile_img_url
        }
      }
    }
  }
}
    `;
export type AddUserToCertificationMutationFn = Apollo.MutationFunction<AddUserToCertificationMutation, AddUserToCertificationMutationVariables>;

/**
 * __useAddUserToCertificationMutation__
 *
 * To run a mutation, you first call `useAddUserToCertificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToCertificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToCertificationMutation, { data, loading, error }] = useAddUserToCertificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddUserToCertificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddUserToCertificationMutation, AddUserToCertificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddUserToCertificationMutation, AddUserToCertificationMutationVariables>(AddUserToCertificationDocument, options);
      }
export type AddUserToCertificationMutationHookResult = ReturnType<typeof useAddUserToCertificationMutation>;
export type AddUserToCertificationMutationResult = Apollo.MutationResult<AddUserToCertificationMutation>;
export type AddUserToCertificationMutationOptions = Apollo.BaseMutationOptions<AddUserToCertificationMutation, AddUserToCertificationMutationVariables>;
export const RemoveUserFromCertificationDocument = gql`
    mutation removeUserFromCertification($id: PositiveInt!, $userId: PositiveInt!) {
  admin {
    certification(id: $id) {
      id
      removeUser(userId: $userId) {
        id
        users {
          id
          image_url
          userIdentity
          profile_img_url
        }
      }
    }
  }
}
    `;
export type RemoveUserFromCertificationMutationFn = Apollo.MutationFunction<RemoveUserFromCertificationMutation, RemoveUserFromCertificationMutationVariables>;

/**
 * __useRemoveUserFromCertificationMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromCertificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromCertificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromCertificationMutation, { data, loading, error }] = useRemoveUserFromCertificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserFromCertificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveUserFromCertificationMutation, RemoveUserFromCertificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveUserFromCertificationMutation, RemoveUserFromCertificationMutationVariables>(RemoveUserFromCertificationDocument, options);
      }
export type RemoveUserFromCertificationMutationHookResult = ReturnType<typeof useRemoveUserFromCertificationMutation>;
export type RemoveUserFromCertificationMutationResult = Apollo.MutationResult<RemoveUserFromCertificationMutation>;
export type RemoveUserFromCertificationMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromCertificationMutation, RemoveUserFromCertificationMutationVariables>;
export const ShareCertificationWithUsersDocument = gql`
    mutation shareCertificationWithUsers($id: PositiveInt!, $userIds: [PositiveInt!]!, $targetDate: DateTime, $message: String, $sendEmail: Boolean!, $resetEnrolments: Boolean!, $emailIdentityId: PositiveInt) {
  admin {
    certification(id: $id) {
      id
      shareWithUsers(
        userIds: $userIds
        targetDate: $targetDate
        message: $message
        sendEmail: $sendEmail
        resetEnrolments: $resetEnrolments
        emailIdentityId: $emailIdentityId
      )
    }
  }
}
    `;
export type ShareCertificationWithUsersMutationFn = Apollo.MutationFunction<ShareCertificationWithUsersMutation, ShareCertificationWithUsersMutationVariables>;

/**
 * __useShareCertificationWithUsersMutation__
 *
 * To run a mutation, you first call `useShareCertificationWithUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareCertificationWithUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareCertificationWithUsersMutation, { data, loading, error }] = useShareCertificationWithUsersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userIds: // value for 'userIds'
 *      targetDate: // value for 'targetDate'
 *      message: // value for 'message'
 *      sendEmail: // value for 'sendEmail'
 *      resetEnrolments: // value for 'resetEnrolments'
 *      emailIdentityId: // value for 'emailIdentityId'
 *   },
 * });
 */
export function useShareCertificationWithUsersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShareCertificationWithUsersMutation, ShareCertificationWithUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShareCertificationWithUsersMutation, ShareCertificationWithUsersMutationVariables>(ShareCertificationWithUsersDocument, options);
      }
export type ShareCertificationWithUsersMutationHookResult = ReturnType<typeof useShareCertificationWithUsersMutation>;
export type ShareCertificationWithUsersMutationResult = Apollo.MutationResult<ShareCertificationWithUsersMutation>;
export type ShareCertificationWithUsersMutationOptions = Apollo.BaseMutationOptions<ShareCertificationWithUsersMutation, ShareCertificationWithUsersMutationVariables>;
export const ShareCertificationWithGroupsDocument = gql`
    mutation shareCertificationWithGroups($id: PositiveInt!, $groupIds: [PositiveInt!]!, $targetDate: DateTime, $message: String, $sendEmail: Boolean!, $resetEnrolments: Boolean!, $emailIdentityId: PositiveInt) {
  admin {
    certification(id: $id) {
      id
      shareWithGroups(
        groupIds: $groupIds
        targetDate: $targetDate
        message: $message
        sendEmail: $sendEmail
        resetEnrolments: $resetEnrolments
        emailIdentityId: $emailIdentityId
      )
    }
  }
}
    `;
export type ShareCertificationWithGroupsMutationFn = Apollo.MutationFunction<ShareCertificationWithGroupsMutation, ShareCertificationWithGroupsMutationVariables>;

/**
 * __useShareCertificationWithGroupsMutation__
 *
 * To run a mutation, you first call `useShareCertificationWithGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareCertificationWithGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareCertificationWithGroupsMutation, { data, loading, error }] = useShareCertificationWithGroupsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      groupIds: // value for 'groupIds'
 *      targetDate: // value for 'targetDate'
 *      message: // value for 'message'
 *      sendEmail: // value for 'sendEmail'
 *      resetEnrolments: // value for 'resetEnrolments'
 *      emailIdentityId: // value for 'emailIdentityId'
 *   },
 * });
 */
export function useShareCertificationWithGroupsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShareCertificationWithGroupsMutation, ShareCertificationWithGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShareCertificationWithGroupsMutation, ShareCertificationWithGroupsMutationVariables>(ShareCertificationWithGroupsDocument, options);
      }
export type ShareCertificationWithGroupsMutationHookResult = ReturnType<typeof useShareCertificationWithGroupsMutation>;
export type ShareCertificationWithGroupsMutationResult = Apollo.MutationResult<ShareCertificationWithGroupsMutation>;
export type ShareCertificationWithGroupsMutationOptions = Apollo.BaseMutationOptions<ShareCertificationWithGroupsMutation, ShareCertificationWithGroupsMutationVariables>;
export const AccessCertificationUsersDocument = gql`
    query accessCertificationUsers($id: PositiveInt!, $limit: NonNegativeInt!, $offset: NonNegativeInt!, $order: [OrderDescriptor!], $filters: [UserModelPublicBaseFilterInput!]) {
  admin {
    certification(id: $id) {
      id
      users(limit: $limit, offset: $offset, order: $order, filters: $filters) {
        id
        display_name
        image_url
        email
      }
      usersCount
    }
  }
}
    `;

/**
 * __useAccessCertificationUsersQuery__
 *
 * To run a query within a React component, call `useAccessCertificationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessCertificationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessCertificationUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order: // value for 'order'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAccessCertificationUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccessCertificationUsersQuery, AccessCertificationUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccessCertificationUsersQuery, AccessCertificationUsersQueryVariables>(AccessCertificationUsersDocument, options);
      }
export function useAccessCertificationUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccessCertificationUsersQuery, AccessCertificationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccessCertificationUsersQuery, AccessCertificationUsersQueryVariables>(AccessCertificationUsersDocument, options);
        }
export type AccessCertificationUsersQueryHookResult = ReturnType<typeof useAccessCertificationUsersQuery>;
export type AccessCertificationUsersLazyQueryHookResult = ReturnType<typeof useAccessCertificationUsersLazyQuery>;
export type AccessCertificationUsersQueryResult = Apollo.QueryResult<AccessCertificationUsersQuery, AccessCertificationUsersQueryVariables>;
export const CertificationIsSharingCompletedDocument = gql`
    query CertificationIsSharingCompleted($id: PositiveInt!) {
  admin {
    certification(id: $id) {
      id
      isSharingCompleted
    }
  }
}
    `;

/**
 * __useCertificationIsSharingCompletedQuery__
 *
 * To run a query within a React component, call `useCertificationIsSharingCompletedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificationIsSharingCompletedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificationIsSharingCompletedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCertificationIsSharingCompletedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CertificationIsSharingCompletedQuery, CertificationIsSharingCompletedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CertificationIsSharingCompletedQuery, CertificationIsSharingCompletedQueryVariables>(CertificationIsSharingCompletedDocument, options);
      }
export function useCertificationIsSharingCompletedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CertificationIsSharingCompletedQuery, CertificationIsSharingCompletedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CertificationIsSharingCompletedQuery, CertificationIsSharingCompletedQueryVariables>(CertificationIsSharingCompletedDocument, options);
        }
export type CertificationIsSharingCompletedQueryHookResult = ReturnType<typeof useCertificationIsSharingCompletedQuery>;
export type CertificationIsSharingCompletedLazyQueryHookResult = ReturnType<typeof useCertificationIsSharingCompletedLazyQuery>;
export type CertificationIsSharingCompletedQueryResult = Apollo.QueryResult<CertificationIsSharingCompletedQuery, CertificationIsSharingCompletedQueryVariables>;